import { Dispatch, SetStateAction } from "react";

import { useTranslation } from "react-i18next";

import { Divider, Form } from "simplydo/react/ui";
import { Input } from "simplydo/react/ui";

import { IYourIdeaFilters } from "components/challenges/YourIdeas";

import Checkbox from "../Forms/Checkbox";
import Radio from "../Forms/Radio";

type YourIdeasFiltersProps = {
  setFilters: Dispatch<SetStateAction<IYourIdeaFilters>>;
  showDraft: boolean;
  showSubmitted: boolean;
  sort: string;
  filter: string;
};

const YourIdeasFilters = ({
  setFilters,
  showDraft,
  showSubmitted,
  sort,
  filter,
}: YourIdeasFiltersProps) => {
  const { t } = useTranslation();
  return (
    <Form style={{ padding: 0 }}>
      <Form.Field
        control={Input}
        placeholder={t("ideas.yours.sidebar.search")}
        icon="search"
        value={filter}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilters((prevState) => ({ ...prevState, filter: e.target.value }))
        }
      />
      <Divider hidden />
      <Checkbox
        label={t("ideas.yours.sidebar.draft")}
        checked={showDraft}
        onChange={() =>
          setFilters((prevState) => ({ ...prevState, showDraft: !showDraft }))
        }
      />
      <Checkbox
        label={t("ideas.yours.sidebar.submitted")}
        checked={showSubmitted}
        onChange={() =>
          setFilters((prevState) => ({
            ...prevState,
            showSubmitted: !showSubmitted,
          }))
        }
      />
      <h5>Order by</h5>
      <Radio
        label={t("order.newest")}
        name="sort"
        checked={sort === "newest"}
        onChange={() =>
          setFilters((prevState) => ({ ...prevState, sort: "newest" }))
        }
      />
      <Radio
        label={t("order.oldest")}
        name="sort"
        checked={sort === "oldest"}
        onChange={() =>
          setFilters((prevState) => ({ ...prevState, sort: "oldest" }))
        }
      />
    </Form>
  );
};

export default YourIdeasFilters;
